import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HolidayGate } from "./components/HolidayGate";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import Products from "./pages/Products";
import CategoryPage from "./pages/CategoryPage";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import EntranceDefense from "./pages/EntranceDefense";
import ResourceCenter from "./pages/ResourceCenter";
import CatalogViewer from "./pages/CatalogViewer";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import AdminApp from "./admin/AdminApp";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Public marketing site (wrapped in the shared Layout)
function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/products" element={<Products />} />
        <Route path="/catalog" element={<CatalogViewer />} />
        <Route path="/holiday-mat-program/*" element={<HolidayGate />} />
        <Route path="/products/:categorySlug" element={<CategoryPage />} />
        <Route path="/products/:categorySlug/:productSlug" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/entrance-defense" element={<EntranceDefense />} />
        <Route path="/resources" element={<ResourceCenter />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Isolated admin CRM — no public site chrome */}
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Public marketing site */}
        <Route path="/*" element={<PublicSite />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
